import { createSelector } from '@ngrx/store';
import { ErrorMessage } from '../error/error-message.model';
import { premiumDiscountLisSelectors, premiumModulesSelectors } from './extra.entity';
import { PremiumState, selectPremiumState } from './extra.state';
import { CouponState } from './extra.model';

// Lista
export const selectPremiumModulesError = createSelector(
	selectPremiumState,
	(state: PremiumState): ErrorMessage => state.premiumModulesList.error
);

export const selectPremiumModules = createSelector(
	selectPremiumState,
	(state: PremiumState) => state.premiumModulesList
);

export const selectAllPremiumModules = createSelector(
	selectPremiumModules,
	premiumModulesSelectors.selectAll
);

export const selectMyErrorToken = createSelector(
	selectPremiumState,
	(state: PremiumState) => state.premiumCheckToken.entities[state.premiumCheckToken.ids[0]]
);

export const selectMyPremium = createSelector(
	selectPremiumState,
	(state: PremiumState) => state.myPremium
);

// export const selectMyPremium = createSelector(
// 	selectPremiumState,
// 	(state: PremiumState) => state.myPremium.entities[state.myPremium.ids[0]]
// );

// Lista
export const selectDiscountTypeList = createSelector(
	selectPremiumState,
	(state: PremiumState) => state.premiumDisconutTypeList
);

export const selectAllDiscountType = createSelector(
	selectDiscountTypeList,
	premiumDiscountLisSelectors.selectAll
);

export const selectPremiumCouponState = createSelector(
	selectPremiumState,
	(state: PremiumState) => state.premiumCoupon
);
export const selectPaymentIntent = createSelector(
	selectPremiumState,
	(state: PremiumState) => state.paymentIntent.completePaymentIntent
);

export const selectPaymentSuccess = createSelector(
	selectPremiumState,
	(state: PremiumState) => state.paymentIntent.paymentSuccess
);
